import { FaTimes, FaWhatsapp } from 'react-icons/fa';
import { useWindowSize } from '@/hooks';
import { useCallback } from 'react';
import './style.less';

const WhatsAppButton: React.FC = () => {
  const { isMobile } = useWindowSize();

  const sendToWhatsapp = useCallback(() => {
    const message = 'Olá! gostaria de tirar uma dúvida.';
    const phone = '553183034550';

    const urlQueryString = new URLSearchParams({
      phone,
      text: message,
    }).toString();

    if (isMobile) {
      window.open(
        `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
        '_blank',
      );
    } else {
      window.open(`https://web.whatsapp.com/send?${urlQueryString}`, '_blank');
    }
  }, []);

  return (
    <>
      <div className="whatsapp-fab-button" onClick={sendToWhatsapp}>
        <div className="whatsapp-info">
          <FaWhatsapp size={24} className="whatsapp-icon" />
          <span className="whatsapp-info-label">Falar com suporte</span>

          <FaTimes size={18} className="whatsapp-info-close" />
        </div>
      </div>
    </>
  );
};

export default WhatsAppButton;
